module.exports = __webpack_public_path__ + "static/media/Comfortaa-Light.f4f489de.eot";